import translationKeys from '@translationKeys'

export default {
  [translationKeys.ALERT]: 'Alert',
  [translationKeys.ALERTS]: 'Alerts',
  [translationKeys.ADD_ALERTS_BUTTON]: 'Add alerts',
  [translationKeys.ADD_EMAIL_ALERTS_TITLE]: 'Add email alert',
  [translationKeys.EDIT_EMAIL_ALERTS_TITLE]: 'Remove or edit alert',
  [translationKeys.EDIT_EMAIL_ALERTS_SUBTITLE]: 'Edit email alert',
  [translationKeys.ADD_ALERTS_IN_APP_ALERT_TOOLTIP]: 'In-App Alert',
  [translationKeys.ADD_ALERTS_EMAIL_ALERT_ADDED_TOOLTIP]: 'Email Alert Added',
  [translationKeys.ADD_ALERTS_IN_APP_ALERT_ADDED_TOOLTIP]: 'In-App Alert Added',
  [translationKeys.ADD_ALERTS_EMAIL_ALERT_TOOLTIP]: 'Email Alert',
  [translationKeys.ALERT_FREQUENCY_DAILY]: 'Daily',
  [translationKeys.ALERT_FREQUENCY_WEEKLY]: 'Weekly',
  [translationKeys.ALERT_FREQUENCY_NO_NOTIFICATION]: 'No email alert',
  [translationKeys.ALERT_WITH_NOTIFICATION_ADDED]: 'notification added',
  [translationKeys.ALERT_ADDED]: 'Alert added',
  [translationKeys.ALERT_ADDED_SUBTITLE]: 'Alerts will show in the custom list',
  [translationKeys.ALERT_ADD_EMAIL_NOTIFICATION]: 'Add email notification',
  [translationKeys.ALERT_ADD_EMAIL_NOTIFICATION_SUBTITLE]: 'Let me know of any changes to this profile',
  [translationKeys.DELETE_ALERTS_TITLE]: 'Deleting profile alert',
  [translationKeys.DELETE_ALERTS_SUBTITLE]: 'Will remove the alerts that you have set',
  [translationKeys.DELETE_ALERTS_SHORTLIST]: 'Delete alert(s)',
  [translationKeys.DELETE_ALERTS_FROM_LIST_TITLE]: 'Removing alerts',
  [translationKeys.DELETE_ALERTS_FROM_LIST_SUBTITLE]: 'This will remove these alerts and delete these profiles from this list.',
  [translationKeys.DELETE_ALERT_FROM_LIST_TITLE]: 'Removing alert',
  [translationKeys.DELETE_ALERT_FROM_LIST_SUBTITLE]: 'This will remove the alert and delete this profile from this list.',
  [translationKeys.ALERTS_DISABLED_LINK]: '{{type}} no longer exists',
}
